import { Tabs, Form, DatePicker, Button, Select, message, Tooltip, Divider, Checkbox, } from 'antd'
import React, { Component } from 'react'
import './graphStatistics.scss'

import {
  getYearConsultation,
  getConsultationVolumeAll,
  GetFirstGroupData,
  getSearchPartSecondData,
  getHospitalListGroups,
  getConsultationApplyHospitalGroup,
} from '@/request/operatorPartApi';

import moment from 'moment';
import { uniqueJsonArrByField, requestErrorLog } from '@/common/util'
const { TabPane } = Tabs;
const { Option } = Select;
const echarts = require('echarts');
export class GraphStatistics extends Component {
  state = {
    showKey: '1',
    startValue: moment(),
    endValue: moment(),
    endOpen: false,
    startOpen: false,
    handlStartValue: moment(),
    handlStartOpen: false,
    handlEndValue: moment(),
    handlEndOpen: false,
    dataList: [],
    showType: 'histogram',
    consultHospitalCode: '',
    consultHospitalName: '',
    applyHospitalCode: '',
    applyHospitalName: '',
    consultHospitalList: [],
    applyHospitalList: [],
    consultSum: {
      ECG_Consulation_Sum: 0,
      HOLTER_Consulation_Sum: 0,
      BP_Consulation_Sum: 0
    },
    paintModalShow: false,
    dataZoomStart: 0,
    dataZoomEnd: 100,
    paintOption: {},
    firstGroupList: [],//一级分组列表
    secondGroupList: [],//一级分组列表
    firstGroupValue: [],
    secondGroupValue: [],
    firstGroupName: '',
    secondGroupName: '',
    operaterInfo: JSON.parse(localStorage.getItem('operaterInfo')),

    selectFirstAllState: false,//一级分组全选框是否选中
    indeterminateFirst: false,//一级分组半选状态是否开启
    selectSecondAllState: false,//二级分组全选框是否选中
    indeterminateSecond: false,//二级分组半选状态是否开启
  }
  handleTabKey = (e) => {
    this.setState({
      showKey: e,
      dataZoomStart: 0,//切换的时候dataZoomStart、dataZoomEnd归到默认值
      dataZoomEnd: 100,
    }, () => {
      this.getDataList()
    })
  }

  handleStartOpenChange = open => {
    if (open) {
      this.setState({ startOpen: true })
    } else {
      this.setState({ startOpen: false })
    }
  };
  handleEndOpenChange = open => {
    this.setState({ endOpen: open });
  };
  handleStartPanelChange = (value) => {
    this.setState({
      startValue: value,
      handlStartValue: value,
      startOpen: false
    })
  }
  handleEndPanelChange = (value) => {
    this.setState({
      endValue: value,
      handlEndValue: value,
      endOpen: false
    })
  }
  StartOpenChange = open => {
    if (open) {
      this.setState({ handlStartOpen: true })
    } else {
      this.setState({ handlStartOpen: false })
    }
  };
  EndOpenChange = open => {
    this.setState({ handlEndOpen: open });
  };
  StartPanelChange = (value) => {
    console.log('有改变')
    this.setState({
      handlStartValue: value,
      startValue: value,
      handlStartOpen: false
    })
  }
  EndPanelChange = (value) => {
    this.setState({
      handlEndValue: value,
      endValue: value,
      handlEndOpen: false,
    })
  }
  async componentDidMount() {
    const { operaterInfo } = this.state
    let hospitalData = operaterInfo.hospitalData.map(item => item.HOSPITAL_CODE).toString()
    let res = await GetFirstGroupData(hospitalData);
    let firstGroupList = []
    if (res && res.Status === 1) {
      firstGroupList = res.Result
    } else {
      requestErrorLog('', '运营综合查询-统计图形-获取一级分组报错', 0, true)
    }
    //二次需求：一级分组为空也请求二级分组列表
    let firstArr = firstGroupList.map(obj => obj.FIRST_GROUP_CODE)
    let secondGroupList = await this.getSearchPartSecondData(firstArr)
    secondGroupList = uniqueJsonArrByField(secondGroupList, 'SECOND_GROUP_NAME')
    let stateObject = {
      firstGroupList,
      secondGroupList,
      consultHospitalCode: '',
    }
    this.setState(stateObject, async () => {
      this.getDataList()
    })
  }
  //获取会诊总量数量
  getConsultationSum = (data) => {
    let ecg = data.ECG_Consulation_Sum.reduce((sum, num) => sum + num, 0);
    let holger = data.HOLTER_Consulation_Sum.reduce((sum, num) => sum + num, 0);
    let blood = data.BP_Consulation_Sum.reduce((sum, num) => sum + num, 0);
    let consultSum = {
      ECG_Consulation_Sum: ecg,
      HOLTER_Consulation_Sum: holger,
      BP_Consulation_Sum: blood
    }
    this.setState({
      consultSum
    })
  }
  //获取数据结果
  getDataList = () => {
    if (moment(this.state.endValue) < moment(this.state.startValue)) {
      message.error('结束时间不得小于开始时间')
      return;
    }
    let FIRST_GROUP_CODE, SECOND_GROUP_CODE
    FIRST_GROUP_CODE = this.state.firstGroupValue ? this.state.firstGroupValue.toString() : ''
    SECOND_GROUP_CODE = this.state.secondGroupValue ? this.state.secondGroupValue.toString() : ''
    if (FIRST_GROUP_CODE === '' && SECOND_GROUP_CODE !== '') {
      if (SECOND_GROUP_CODE.split(',').length > 1) {//如果不选一级分组只选二级分组，多选情况下需要取二级分组的名称
        let secondGroupArr = SECOND_GROUP_CODE.split(',')
        SECOND_GROUP_CODE = this.state.secondGroupList.filter(item => secondGroupArr.indexOf(item.SECOND_GROUP_CODE) > -1).map(item => item.SECOND_GROUP_NAME).toString()
      } else {
        SECOND_GROUP_CODE = this.state.secondGroupList.find(item => item.SECOND_GROUP_CODE === SECOND_GROUP_CODE).SECOND_GROUP_NAME
      }
    }
    const { operaterInfo } = this.state
    let params = {
      QUERY_BEG_YEAR: moment(this.state.startValue).format('YYYY'),
      QUERY_END_YEAR: moment(this.state.endValue).format('YYYY'),
      FIRST_GROUP_CODE,//一级分组
      SECOND_GROUP_CODE,//二级分组
      LOGIN_UID: operaterInfo.OPERATION_UID
    }
    if (this.state.showKey === '1') {
      params.FIRST_GROUP_CODE = operaterInfo.firstGroupData.map(item => item.FIRST_GROUP_CODE).toString()
      params.SECOND_GROUP_CODE = operaterInfo.secondGroupData.map(item => item.SECOND_GROUP_CODE).toString()
      this.getConsultationAllList(params)
    } else {
      this.getHospitalDiagnosisList(params)
    }
  }
  //会诊总量查询
  getConsultationAllList = (params) => {
    params.APPLY_HOSPITAL_CODE = '';
    params.HOSPITAL_CODE = '';
    if (this.state.showType === 'histogram') {
      getConsultationVolumeAll(params).then(res => {
        if (res && res.Status === 1) {
          console.log(res)
          this.setState({
            dataList: res.Result
          })
          this.cylinderStatistics(res.Result)
        } else {
          requestErrorLog('', '运营综合查询-统计图形-柱状图会诊总量查询报错', 0, true)
        }
      })
    } else {
      getYearConsultation(params).then(res => {
        console.log(res)
        if (res && res.Status === 1) {
          this.setState({
            dataList: res.Result,
          })
          this.datasetStatistics(res.Result)
        } else {
          requestErrorLog('', '运营综合查询-统计图形-趋势图会诊总量查询报错', 0, true)
        }
      })
    }
  }
  cylinderStatistics = (data) => {
    let that = this
    this.getConsultationSum(data)
    var dom;
    if (this.state.showKey === '1') {
      dom = document.getElementById("container");
    } else {
      dom = document.getElementById('containerAll');
    }
    if (!dom.clientWidth || !dom.clientHeight) {//dom如果没加载出来，不初始化echarts，避免报错
      return;
    }
    var myChart = echarts.init(dom);
    var option;
    option = {
      title: {
        // text: '会诊统计表',
        // subtext: 'XX医院'
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        }
      },
      legend: {
        data: ['静息心电', '动态心电', '动态血压'],
        right: '5%',
        top: '0',
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      xAxis: {
        type: 'value',
        boundaryGap: [0, 0.01]
      },
      yAxis: {
        type: 'category',
        data: data.HOSPITAL_NAME || data.APPLY_HOSPITAL_NAME,
        axisLabel: {
          interval: 0,      //45度角倾斜
          rotate: 0,
        }
      },
      series: [
        {
          name: '静息心电',
          type: 'bar',
          data: data.ECG_Consulation_Sum,
        },
        {
          name: '动态心电',
          type: 'bar',
          data: data.HOLTER_Consulation_Sum,
        },
        {
          name: '动态血压',
          type: 'bar',
          data: data.BP_Consulation_Sum,
        }
      ],
      dataZoom: [//给x轴设置滚动条
        {
          start: 0,//默认为0
          end: 100,//默认为100
          type: 'slider',
          maxValueSpan: 9,//显示数据的条数(默认显示10个)
          show: true,
          // yAxisIndex: [0],
          handleSize: '30',//滑动条的 左右2个滑动条的大小
          height: '100%',//组件高度
          width: 20,
          right: 3,//右边的距离
          top: 50,//上边边的距离
          borderColor: "rgba(43,48,67,0.8)",
          fillerColor: '#33384b',//滑动块的颜色
          backgroundColor: 'rgba(13,33,117,0.5)',//两边未选中的滑动条区域的颜色
          showDataShadow: false,//是否显示数据阴影 默认auto
          showDetail: false,//即拖拽时候是否显示详细数值信息 默认true
          realtime: true, //是否实时更新
          filterMode: 'filter',
          yAxisIndex: [0, 1],//控制的y轴
        },
        //滑块的属性
        {
          type: 'inside',
          show: true,
          yAxisIndex: [0, 1],
          start: 1,//默认为1
          end: 9,//默认为100
        },
      ],
    };
    myChart.on('dataZoom', function (params) {
      let dataZoomStart = 0, dataZoomEnd = 100
      if (params.batch) {
        dataZoomStart = params.batch[0].start
        dataZoomEnd = params.batch[0].end
      } else {
        dataZoomStart = params.start
        dataZoomEnd = params.end
      }
      that.setState({
        dataZoomStart,
        dataZoomEnd
      })
    })
    that.setState({
      paintOption: option
    })
    myChart.setOption(option);
  }
  datasetStatistics = (data) => {
    var chartDom
    let that = this
    if (this.state.showKey === '1') {
      chartDom = document.getElementById('main');
    } else {
      chartDom = document.getElementById('mainAll');
    }
    if (!chartDom.clientWidth || !chartDom.clientHeight) {//dom如果没加载出来，不初始化echarts，避免报错
      return;
    }
    var myChart = echarts.init(chartDom);
    var option;
    let product = ['product'].concat(data.YEARDATE || data.MONTHDATE);
    let ECG = ['静息心电'].concat(data.ECG_Consulation_Sum);
    let Holter = ['动态心电'].concat(data.HOLTER_Consulation_Sum);
    let BP = ['动态血压'].concat(data.BP_Consulation_Sum);
    let Exit = ['退回'].concat(data.Exit_Sum);
    this.getConsultationSum(data)
    setTimeout(function () {

      option = {
        // title: {
        //   text: '折线图',
        //   subtext: '模拟数据',
        //   x: 'center'
        // },
        legend: {
          orient: 'vertical',
          right: '10%',
          top: '10%',
          textStyle: {
            color: '#333',
            fontSize: 14,
          },
        },
        tooltip: {
          trigger: 'axis',
          showContent: false
        },
        dataset: {
          source: [product, ECG, Holter, BP, Exit]
        },
        xAxis: { type: 'category' },
        yAxis: { gridIndex: 0 },
        grid: { top: '55%' },
        series: [
          { type: 'line', smooth: true, seriesLayoutBy: 'row', emphasis: { focus: 'series' } },
          { type: 'line', smooth: true, seriesLayoutBy: 'row', emphasis: { focus: 'series' } },
          { type: 'line', smooth: true, seriesLayoutBy: 'row', emphasis: { focus: 'series' } },
          { type: 'line', smooth: true, seriesLayoutBy: 'row', emphasis: { focus: 'series' } },
          {
            type: 'pie',
            id: 'pie',
            radius: '30%',
            center: ['50%', '25%'],
            emphasis: { focus: 'data' },
            label: {
              formatter: `{b}: {@${product[1]}} ({d}%)`
            },
            encode: {
              itemName: 'product',
              value: product[1],
              tooltip: product[1]
            }
          }
        ]
      };
      myChart.on('updateAxisPointer', function (event) {
        var xAxisInfo = event.axesInfo[0];
        if (xAxisInfo) {
          var dimension = xAxisInfo.value + 1;
          myChart.setOption({
            series: {
              id: 'pie',
              label: {
                formatter: '{b}: {@[' + dimension + ']} ({d}%)'
              },
              encode: {
                value: dimension,
                tooltip: dimension
              }
            }
          });
          option.series[4] = {
            type: 'pie',
            id: 'pie',
            radius: '30%',
            center: ['50%', '25%'],
            emphasis: { focus: 'data' },
            label: {
              formatter: '{b}: {@[' + dimension + ']} ({d}%)'
            },
            encode: {
              itemName: 'product',
              value: dimension,
              tooltip: dimension
            }
          }
          that.setState({
            paintOption: option
          })
        }
      });

      that.setState({
        paintOption: option
      })
      myChart.setOption(option);
    });
  }
  showTypeChange = (type) => {
    if (type !== this.state.showType) {
      this.setState({
        showType: type
      }, () => {
        this.getDataList()
      })
    }
  }
  // 请求会诊医院列表
  initHospitalList(FIRST_GROUP_CODE, SECOND_GROUP_CODE) {
    FIRST_GROUP_CODE = FIRST_GROUP_CODE.toString()
    SECOND_GROUP_CODE = SECOND_GROUP_CODE.toString()
    const { operaterInfo } = this.state
    let HOSPITAL_CODE = operaterInfo.hospitalData.map(item => item.HOSPITAL_CODE).toString()
    let Param = {
      Type: "GetConsultationHospitalData",
      HOSPITAL_CODE,
      FIRST_GROUP_CODE,//一级分组
      SECOND_GROUP_CODE,//二级分组
    }
    getHospitalListGroups(Param).then((res) => {
      if (res && res.Status === 1) {
        this.setState({
          consultHospitalList: res.Result || []
        })
      } else {
        requestErrorLog('', '运营综合查询-统计图形-会诊医院列表报错', 0, true)
      }
    })
  }
  //会诊医院改变
  consultHospitalChange = async (code, secondGroupData) => {
    let applyHospitalList = []
    let stateObject = {
      applyHospitalList,
      applyHospitalCode: '',
      consultHospitalCode: code,
    }
    if (code !== '') {//code选中，请求申请医院列表，否则清空列表数据即可
      let FIRST_GROUP_CODE = this.state.firstGroupValue ? this.state.firstGroupValue.toString() : '';
      let SECOND_GROUP_CODE = Array.isArray(secondGroupData) ? secondGroupData.toString() : this.state.secondGroupValue ? this.state.secondGroupValue.toString() : '';

      const { operaterInfo } = this.state
      let Param = {
        Type: "GetApplyHospitalData",
        HOSPITAL_CODE: code,
        FIRST_GROUP_CODE,
        SECOND_GROUP_CODE, //大屏模块用字段BELONG_GROUP，医联体模块字段用DATA_GROUP
        OPERATION_UID: operaterInfo.OPERATION_UID,
      }
      let res = await getConsultationApplyHospitalGroup(Param);
      if (res && res.Status === 1) {
        stateObject.applyHospitalList = res.Result ? res.Result : [];
      } else {
        requestErrorLog('', '运营综合查询-统计图形-申请议员列表报错', 0, true)
      }

    }
    if (Array.isArray(secondGroupData)) {
      return stateObject.applyHospitalList
    }
    this.setState(stateObject)
  }
  applyHospitalChange = (code) => {
    this.setState({
      applyHospitalCode: code
    })
  }
  getHospitalDiagnosisList = (params) => {

    params.APPLY_HOSPITAL_CODE = this.state.applyHospitalCode;
    params.HOSPITAL_CODE = this.state.consultHospitalCode;
    if (this.state.showType === 'histogram') {
      getConsultationVolumeAll(params).then(res => {
        if (res && res.Status === 1) {
          this.cylinderStatistics(res.Result)
        } else {
          requestErrorLog('', '运营综合查询-统计图形-机构总诊量趋势图查询报错', 0, true)
        }
      })
    } else {
      getYearConsultation(params).then(res => {
        let name = this.getConsultationName('consult')
        let applyName = this.getConsultationName()
        if (res && res.Status === 1) {
          this.datasetStatistics(res.Result)
          this.setState({
            consultHospitalName: name
          })
          if (this.state.applyHospitalCode) {
            this.setState({
              applyHospitalName: applyName
            })
          } else {
            this.setState({
              applyHospitalName: ''
            })
          }
        } else {
          requestErrorLog('', '运营综合查询-统计图形-机构总诊量柱状图查询报错', 0, true)
        }
      })
    }
  }
  //根据code获取医院名称
  getConsultationName = (type) => {
    let name = '';
    if (type === 'consult') {
      this.state.consultHospitalList.forEach(item => {
        if (item.HOSPITAL_CODE === this.state.consultHospitalCode) {
          name = item.HOSPITAL_NAME
        }
      })
    } else {
      this.state.applyHospitalList.forEach(item => {
        if (item.APPLY_HOSPITAL_CODE === this.state.applyHospitalCode) {
          name = item.APPLY_HOSPITAL_NAME
        }
      })
    }

    return name
  }
  //一级组别变化
  firstGroupChange = async (firstGroupCode) => {
    //非平台管理和监管机构账号，会诊机构不允许清空,列表数据也对应重新获取或者清空
    let secondGroupList, firstGroupName
    let stateObject = {
      firstGroupValue: firstGroupCode,
      firstGroupName: '',
      secondGroupName: '',
      secondGroupValue: undefined,
      secondGroupList: [],//二级分组列表数据
      consultHospitalList: [],//会诊医院列表
      consultHospitalCode: '',
      applyHospitalCode: '',
      applyHospitalList: [],
    }
    if (firstGroupCode.length > 0) {
      secondGroupList = await this.getSearchPartSecondData(firstGroupCode)
      firstGroupName = this.state.firstGroupList.filter(item => firstGroupCode.indexOf(item.FIRST_GROUP_CODE) > -1).map((item) => { return item.FIRST_GROUP_NAME })
      stateObject.secondGroupList = secondGroupList;
      stateObject.firstGroupName = firstGroupName;
    } else {//二次需求：一级分组为空也请求二级分组列表
      let firstArr = this.state.firstGroupList.map(obj => obj.FIRST_GROUP_CODE)
      secondGroupList = await this.getSearchPartSecondData(firstArr)
      secondGroupList = uniqueJsonArrByField(secondGroupList, 'SECOND_GROUP_NAME')
      stateObject.secondGroupList = secondGroupList;
    }
    //分组1勾选时，给分组二的全选框赋空
    stateObject.indeterminateSecond = false;
    stateObject.selectSecondAllState = false;
    //选中的数据不等于全选的数据长度，全选框为半选状态
    if (firstGroupCode.length > 0 && firstGroupCode.length < this.state.firstGroupList.length) {
      stateObject.indeterminateFirst = true
    } else {
      stateObject.indeterminateFirst = false
      if (firstGroupCode.length === this.state.firstGroupList.length) {
        stateObject.selectFirstAllState = true
      } else {
        stateObject.selectFirstAllState = false
      }
    }
    this.setState(stateObject)

  }	//二级组别变化
  secondGroupChange = async (secondGroupData) => {
    if (this.state.firstGroupValue.length > 0) {//二次需求：一级分组为空也请求二级分组列表；单纯二级分组发生变化，不处理原来搜索框联动逻辑
      let secondGroupName = this.state.secondGroupList.filter(item => secondGroupData.indexOf(item.SECOND_GROUP_CODE) > -1).map((item) => { return item.SECOND_GROUP_NAME })
      this.setState({
        secondGroupValue: secondGroupData,
        secondGroupName: secondGroupData.length > 0 ? secondGroupName : '',
      })
      let stateObject = {
        consultHospitalList: [],//会诊医院列表
        consultHospitalCode: '',//会诊机构下拉框清空
        applyHospitalCode: '',
        applyHospitalList: [],
      }
      if (secondGroupData.length > 0) {//管理员以及监管机构，以及二级分组有数据时获取会诊医院列表
        this.initHospitalList(this.state.firstGroupValue, secondGroupData);
      }
      this.setState(stateObject)
    } else {
      let secondGroupName = this.state.secondGroupList.filter(item => secondGroupData.indexOf(item.SECOND_GROUP_CODE) > -1).map((item) => { return item.SECOND_GROUP_NAME })
      this.setState({
        secondGroupValue: secondGroupData,
        secondGroupName: secondGroupData.length > 0 ? secondGroupName : '',
      })
    }
    //分组1勾选时，给分组二的全选框赋空
    let indeterminateSecond = false;
    let selectSecondAllState = false;
    //选中的数据不等于全选的数据长度，全选框为半选状态
    if (secondGroupData.length > 0 && secondGroupData.length < this.state.secondGroupList.length) {
      indeterminateSecond = true
    } else {
      if (secondGroupData.length === this.state.secondGroupList.length) {
        selectSecondAllState = true
      }
    }
    this.setState({
      indeterminateSecond,
      selectSecondAllState
    })
  }
  //请求二级分组列表
  async getSearchPartSecondData(firstGroupData) {
    let res = await getSearchPartSecondData("E00144", '', firstGroupData.toString())
    if (res && res.Status === 1) {
      return res.Result ? res.Result : []
    } else {
      requestErrorLog('', '运营综合查询-统计图形-获取二级分组列表报错', 0, true)
      return []
    }
  }
  handleFirstChange = (e) => {
    let firstGroupValue = []
    if (e.target.checked) {//取做所有一级分组值赋给一级分组
      firstGroupValue = this.state.firstGroupList ? this.state.firstGroupList?.map((item) => item.FIRST_GROUP_CODE) : []
    }
    this.firstGroupChange(firstGroupValue)
  }
  handleSecondChange = (e) => {
    let secondGroupValue = []
    if (e.target.checked) {//取做所有一级分组值赋给一级分组
      secondGroupValue = this.state.secondGroupList ? this.state.secondGroupList?.map((item) => item.SECOND_GROUP_CODE) : []
    }
    this.secondGroupChange(secondGroupValue)
  }
  render() {
    const { startValue, endValue, endOpen, startOpen, handlStartValue, handlStartOpen, handlEndValue, handlEndOpen, consultSum, firstGroupValue, firstGroupList, secondGroupValue, secondGroupList, firstGroupName, secondGroupName } = this.state;
    let firstGroupLength = '+' + firstGroupValue?.length.toString();
    let secondGroupLength = '+' + secondGroupValue?.length.toString();
    return (
      <>
        <div className="eleWrap applyTd" style={{ flex: 1 }}>
          <Tabs defaultActiveKey={this.state.showKey} type="card" onChange={this.handleTabKey}>
            <TabPane
              key="1"
              tab={<p className="badgeText">会诊总量查询</p>}
            >
              <div className="commonCase">
                <div className="datePickerBox">
                  <span>查询年度：</span>
                  <DatePicker
                    mode='year'
                    placeholder="请选择开始日期"
                    format="YYYY"
                    allowClear={false}
                    value={startValue}
                    open={startOpen}
                    onOpenChange={this.handleStartOpenChange}
                    onPanelChange={this.handleStartPanelChange}
                  />
                  <span className="interval">-</span>
                  <DatePicker
                    mode='year'
                    placeholder="请选择结束日期"
                    value={endValue}
                    format="YYYY"
                    allowClear={false}
                    open={endOpen}
                    onOpenChange={this.handleEndOpenChange}
                    onPanelChange={this.handleEndPanelChange}
                  />
                  <Button onClick={this.getDataList}>查询</Button>
                  {/* <Button onClick={() => {
                    this.setState({
                      paintModalShow: true
                    })
                  }}>打印</Button> */}
                </div>
              </div>
              <div>
                <div className="gtaphBtn">
                  <Button className={this.state.showType === 'histogram' ? 'active' : ''} onClick={this.showTypeChange.bind(this, 'histogram')}>柱状图</Button>
                  <Button className={this.state.showType === 'tendency' ? 'active' : ''} onClick={this.showTypeChange.bind(this, 'tendency')}>趋势图</Button>
                </div>
                <div id="container" style={{ height: '750px', display: this.state.showType === 'histogram' ? 'block' : 'none' }}></div>
                <div id="main" style={{ height: '700px', display: this.state.showType === 'tendency' ? 'block' : 'none' }}></div>
                <div className="graphTotalBox">
                  会诊总量：
                  <span></span>静息心电 - {consultSum.ECG_Consulation_Sum}例
                  <span></span>动态心电 - {consultSum.HOLTER_Consulation_Sum}例
                  <span></span>动态血压 - {consultSum.BP_Consulation_Sum}例
                </div>
              </div>
            </TabPane>
            <TabPane
              key="2"
              tab={<p className="badgeText">机构总诊量查询</p>}
            >
              <div className="commonCase">
                <div className="datePickerBox">
                  <span>查询年度：</span>
                  <DatePicker
                    mode='year'
                    placeholder="请选择开始日期"
                    format="YYYY"
                    value={handlStartValue}
                    open={handlStartOpen}
                    allowClear={false}
                    onOpenChange={this.StartOpenChange}
                    onPanelChange={this.StartPanelChange}
                    style={{ width: '90px' }}
                  />
                  <span className="interval">-</span>
                  <DatePicker
                    mode='year'
                    placeholder="请选择结束日期"
                    format="YYYY"
                    value={handlEndValue}
                    open={handlEndOpen}
                    allowClear={false}
                    onOpenChange={this.EndOpenChange}
                    onPanelChange={this.EndPanelChange}
                    style={{ width: '90px' }}
                  />
                  <span className="institution">一级分组：</span>
                  <Tooltip overlayClassName='tooltipColor' title={firstGroupName.toString()}>
                    <Select
                      mode="multiple"
                      value={firstGroupValue}
                      allowClear
                      showSearch
                      optionFilterProp="children"
                      maxTagCount={1}
                      maxTagPlaceholder={firstGroupLength}
                      maxTagTextLength={4}
                      onChange={this.firstGroupChange}
                      className='noWrapSelect'
                      dropdownRender={(allSelectValue) => (
                        <div>
                          <div style={{ padding: "4px 8px 8px 8px", cursor: "pointer" }} onMouseDown={e => e.preventDefault()}>
                            <Checkbox
                              checked={this.state.selectFirstAllState}
                              onChange={this.handleFirstChange}
                              indeterminate={this.state.indeterminateFirst}
                            >
                            </Checkbox>
                            &nbsp;&nbsp;全选
                          </div>
                          <Divider style={{ margin: "0" }} />
                          {allSelectValue}
                        </div>
                      )}
                    >
                      {firstGroupList.map((item, index) => (
                        <Option key={index + item.FIRST_GROUP_CODE} value={item.FIRST_GROUP_CODE} title={item.FIRST_GROUP_NAME}>
                          {item.FIRST_GROUP_NAME}
                        </Option>
                      ))}
                    </Select></Tooltip>
                  <span className="institution">二级分组：</span>
                  <Tooltip overlayClassName='tooltipColor' title={secondGroupName.toString()}>
                    <Select
                      mode="multiple"
                      value={secondGroupValue}
                      allowClear
                      showSearch
                      optionFilterProp="children"
                      maxTagCount={1}
                      maxTagPlaceholder={secondGroupLength}
                      maxTagTextLength={4}
                      onChange={this.secondGroupChange}
                      className='noWrapSelect'
                      dropdownRender={(allSelectValue) => (
                        <div>
                          <div style={{ padding: "4px 8px 8px 8px", cursor: "pointer" }} onMouseDown={e => e.preventDefault()}>
                            <Checkbox
                              checked={this.state.selectSecondAllState}
                              onChange={this.handleSecondChange}
                              indeterminate={this.state.indeterminateSecond}
                            >
                            </Checkbox>
                            &nbsp;&nbsp;全选
                          </div>
                          <Divider style={{ margin: "0" }} />
                          {allSelectValue}
                        </div>
                      )}
                    >
                      {secondGroupList.map((item, index) => (
                        <Option key={index} value={item.SECOND_GROUP_CODE} title={item.SECOND_GROUP_NAME}>
                          {item.SECOND_GROUP_NAME}
                        </Option>
                      ))}
                    </Select>
                  </Tooltip>
                  <span className="institution">会诊机构：</span>
                  <Select
                    onChange={this.consultHospitalChange}
                    value={this.state.consultHospitalCode}
                    showSearch
                    optionFilterProp='children'
                  >
                    <Option value="">全部</Option>
                    {this.state.consultHospitalList ? this.state.consultHospitalList.map((item) => (
                      <Option key={item.HOSPITAL_CODE + item.HOSPITAL_CODE} value={item.HOSPITAL_CODE}>
                        {item.HOSPITAL_NAME}
                      </Option>
                    )) : null}
                  </Select>
                  <span className="institution">申请机构：</span>
                  <Select
                    onChange={this.applyHospitalChange}
                    value={this.state.applyHospitalCode}
                    showSearch
                    optionFilterProp='children'
                  >
                    <Option value="">全部</Option>
                    {this.state.applyHospitalList.map((item) => (
                      <Option key={item.APPLY_HOSPITAL_CODE + item.APPLY_HOSPITAL_NAME} value={item.APPLY_HOSPITAL_CODE}>
                        {item.APPLY_HOSPITAL_NAME}
                      </Option>
                    ))}
                  </Select>
                  <Button onClick={this.getDataList}>查询</Button>
                  {/* <Button onClick={() => {
                    this.setState({
                      paintModalShow: true
                    })
                  }}>打印</Button> */}
                </div>
              </div>
              <div>
                <div className="gtaphBtn">
                  <Button className={this.state.showType === 'histogram' ? 'active' : ''} onClick={this.showTypeChange.bind(this, 'histogram')}>柱状图</Button>
                  <Button className={this.state.showType === 'tendency' ? 'active' : ''} onClick={this.showTypeChange.bind(this, 'tendency')}>趋势图</Button>
                </div>
                <div id="containerAll" style={{ height: '750px', display: this.state.showType === 'histogram' ? 'block' : 'none' }}></div>
                {this.state.showType === 'tendency' && this.state.consultHospitalName && !this.state.applyHospitalName ?
                  <div className="consultHospitalTitle">会诊机构：{this.state.consultHospitalName}</div> : null
                }
                {this.state.showType === 'tendency' && this.state.applyHospitalName ?
                  <div className="consultHospitalTitle">申请机构：{this.state.applyHospitalName}</div> : null
                }
                <div id="mainAll" style={{ height: '700px', display: this.state.showType === 'tendency' ? 'block' : 'none' }}></div>
                <div className="graphTotalBox">
                  会诊总量：
                  <span></span>静息心电 - {consultSum.ECG_Consulation_Sum}例
                  <span></span>动态心电 - {consultSum.HOLTER_Consulation_Sum}例
                  <span></span>动态血压 - {consultSum.BP_Consulation_Sum}例
                </div>
              </div>
            </TabPane>
          </Tabs>
        </div>
      </>
    )
  }
}

export default Form.create()(GraphStatistics)
